module.exports = __webpack_public_path__ + "static/media/step1_2.e4fb0af7.png";